module.exports = new __parcel__URL__("mmnumberkeyboard.6cec1f4f.webp").toString();